import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5302dc4f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "blog-main blog-container" }
const _hoisted_2 = { class: "blog" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Node.js is a server-side JavaScript environment that allows developers to run JavaScript code on the server rather than just in the browser. Here will explain the simplest way to set up a counter incrementer server. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " To implement a Node.js Express server and maintain a counter, you'll need to set up a simple API endpoint from the front-end app to increment/decrement and update the counter accordingly. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Create a new directory for your project and initialize a Node.js project using npm or yarn. ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Install Express to create the server.", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "In the root of the project, create a file that will contain the express server code. Call it server.js or index.js", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "In the server.js lets import express, and use it. Lets also use bodyParser to parse JSON data from the request body.", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Now lets try to start the server. Add in this code and run the command node server.js in the terminal", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "You will see the console log if the server is running successfully.", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Next we will need to initialize a counter variable.", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Create end point to update the counter.", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Add another end point to subtract from the counter if you'd like.", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "In your front end app, you can make requests to this end point to update the counter. Here is a simple Vue template that will work for this. We will use axios to make requests.", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Test it out and see if it works. Make sure the server is running and are making the request to the correct url. That's it!", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "There are several user-friendly hosting platforms that make it easy to deploy and manage web applications, including Node.js apps. Here are some simple and popular hosting ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blog-links mb-4 d-flex" }, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://id.heroku.com/login",
    class: "mx-1"
  }, "Heroku"),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://vercel.com/",
    class: "mx-1"
  }, "Vercel"),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://www.netlify.com/",
    class: "mx-1"
  }, "Netlify")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Make sure to switch to the correct url in the front-end given from the hosting platform after deploying.", -1))

import { ref } from 'vue'
  import BlogImage from './utilities/BlogImage.vue'
  import CodeSnippet from './utilities/CodeSnippet.vue'
  import Credit from './Credit.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'NodeExpressBlog',
  setup(__props) {

  const part1 = ref<HTMLElement | null>(null)
  const part2 = ref<HTMLElement | null>(null)
  const part3 = ref<HTMLElement | null>(null)

  function scrollPart1() {
    part1.value?.scrollIntoView({ behavior: 'smooth' })
  }
  function scrollPart2() {
    part2.value?.scrollIntoView({ behavior: 'smooth' })
  }
  function scrollPart3() {
    part3.value?.scrollIntoView({ behavior: 'smooth' })
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", { class: "blog-links mb-4 d-flex" }, [
        _createElementVNode("span", {
          onClick: scrollPart1,
          class: "mx-1"
        }, "Setup"),
        _createElementVNode("span", {
          onClick: scrollPart2,
          class: "mx-1"
        }, "Create Server"),
        _createElementVNode("span", {
          onClick: scrollPart3,
          class: "mx-1"
        }, "Deploy")
      ]),
      _hoisted_3,
      _createElementVNode("h2", {
        ref_key: "part1",
        ref: part1
      }, "Setup", 512),
      _hoisted_4,
      _hoisted_5,
      _createVNode(CodeSnippet, {
        lang: "",
        code: "npm init"
      }),
      _hoisted_6,
      _createVNode(CodeSnippet, {
        lang: "",
        code: "npm install express"
      }),
      _createElementVNode("h2", {
        class: "mt-5",
        ref_key: "part2",
        ref: part2
      }, "Create Server", 512),
      _hoisted_7,
      _hoisted_8,
      _createVNode(CodeSnippet, {
        lang: "server.js",
        code: "const express = require('express');\nconst app = express();\nconst bodyParser = require('body-parser'); \n\napp.use(bodyParser.json());"
      }),
      _hoisted_9,
      _createVNode(CodeSnippet, {
        lang: "server.js",
        code: "const port = 3000; // You can change this to any desired port number\napp.listen(port, () => {\n  console.log(`Server is running on ${port}`);\n});"
      }),
      _hoisted_10,
      _hoisted_11,
      _createVNode(CodeSnippet, {
        lang: "server.js",
        code: "let counter = 0;"
      }),
      _hoisted_12,
      _createVNode(CodeSnippet, {
        lang: "server.js",
        code: "app.get('/increment', (req, res) => {\n  counter++\n  res.json({ vueCounter })\n})"
      }),
      _hoisted_13,
      _hoisted_14,
      _createVNode(CodeSnippet, {
        lang: "vue",
        code: "<script setup lang='ts'\n      import { ref } from 'vue'\n      import axios from 'axios'\n\n      const counter = ref(0);\n      \n      function increment (){\n        axios\n      .get('https //localhost:3000/increment')\n      .then((response: any) => {\n        counter.value = response.data.counter\n      }\n    </script>\n    <template>\n        <div class='counter-app'>\n            <button @click='increment'>add</button>\n            <span>{{ counter }}</span>\n        </div>    \n    </template>    \n      "
      }),
      _hoisted_15,
      _createElementVNode("h2", {
        class: "mt-5",
        ref_key: "part2",
        ref: part2
      }, "Deploy", 512)
    ]),
    _hoisted_16,
    _hoisted_17,
    _hoisted_18,
    _createVNode(Credit)
  ]))
}
}

})